module.exports = __webpack_public_path__ + "img/2021-01-29.a57f636b.jpg";